import styled from 'styled-components'

export const FormQuickConnectOuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-top: 1px;
  padding-bottom: 1px;
`
export const StartupSection = styled.div`
  display: grid;
  gap: 16px;
`

export const ConnectionSection = styled.div`
  display: grid;
  gap: 16px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-size: 16px;
  font-family: Sundry;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  color: #111827;
  text-align: left;
  &.required::after {
    content: ' *';
    color: #dc3545;
  }
`
export const SubTitle = styled.label`
font-size: 16px;
font-family: Sundry;
font-style: normal;
font-weight: 500;
line-height: 140%;
color: #838383;
text-align: left;
`

export const Select = styled.select`
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  outline: none;
  background: #ffffff;
  color: #111827;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px 16px;
  padding-right: 36px;

  &:focus {
    border-color: #6b7280;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`

export const Input = styled.input`
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  outline: none;
  background: #ffffff;
  color: #111827;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #6b7280;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`

export const TextArea = styled.textarea`
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  outline: none;
  background: #ffffff;
  color: #111827;
  resize: vertical;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #6b7280;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`

export const ErrorText = styled.span`
  color: #b91c1c;
  font-size: 12px;
  line-height: 16px;
`